import productionContent from "./images/admin-icon-2/Content.png";
import productionLogo from "./images/admin-icon-2/Logo.png";
import developmentContent from "./images/admin-icon-2/development/Content.png";
import developmentLogo from "./images/admin-icon-2/development/Logo.png";

const isDevelopment = process.env.REACT_APP_NODE_ENV === "development";

export const managerContent = isDevelopment ? developmentContent : productionContent;
export const managerLogo = isDevelopment ? developmentLogo : productionLogo;
